/* Grid of the industry packs (home page, /industries index, "other industries" on each industry page), linking to the
 * pages of the current marketing country ("/ae/industries/garage"). */
import { INDUSTRIES } from "../../../domain/industry";
import { useI18n } from "../../../i18n";
import { Icon } from "../../../ui";
import { MktLink } from "../components/MktLink";
import { inCountry, useMktCountry } from "../mktCountry";
import { industryIn, liveIn } from "../mktLocal";
import "./industries.css";

export const liveCount = (k: string) => INDUSTRIES.find((c) => c.key === k)!.features.filter((f) => f.status === "live").length;

export function IndustryCards({ exclude }: { exclude?: string }) {
  const { L } = useI18n();
  const cc = useMktCountry();
  return (
    <div className="ind-cards" data-testid="industry-cards">
      {INDUSTRIES.filter((c) => c.key !== exclude).map((c) => (
        <MktLink key={c.key} to={inCountry("/industries/" + c.key, cc)} className="ind-card" data-testid={"ind-card-" + c.key}>
          <span className="mod-ico"><Icon name={c.icon} /></span>
          <b>{L(...c.name)}</b>
          <span className="ind-card-t">{L(...industryIn(c, cc).tagline)}</span>
          <span className="ind-card-f xs">
            <span className="chip ok">{L(`${liveIn(c, cc)} live features`, `${liveIn(c, cc)} ميزة متاحة`)}</span>
            <Icon name="chevron-right" className="s" />
          </span>
        </MktLink>
      ))}
    </div>
  );
}
